export const FB_PIXEL_OPTIONS = {
  dataProcessingOptions: [[], 0, 0],
}
